import { CardContent, Card } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { withRouter } from "react-router-dom";
import SubmenuHeader from "../components/menus/SubMenuHeader";
import { get, messageDialog } from "../js/auth";
import CardHeader from '@material-ui/core/CardHeader';

import { makeStyles } from '@material-ui/core/styles';
import WoltOAuth from "./WoltOAuth";
import Button from "@material-ui/core/Button";


class Wolt extends Component {

    state = {
    }

    constructor(props) {
        super(props);

        this.useStyles = makeStyles((theme) => ({
            root: {
                width: '100%',
            },
            heading: {
                fontSize: theme.typography.pxToRem(15),
                flexBasis: '33.33%',
                flexShrink: 0,
            },
            secondaryHeading: {
                fontSize: theme.typography.pxToRem(15),
                color: theme.palette.text.secondary,
            },
        }));
    }

    render() {
        if (!this.props.myStatus || !this.props.myStatus.restaurant_settings || !this.props.myStatus.restaurant_settings["enabled-features"] || !this.props.myStatus.restaurant_settings["enabled-features"].wolt) {
            return <div></div>;
        }
        return <div style={{ flexGrow: 1, flexShrink: 1, display: "flex", flexFlow: "column", overflowY: "hidden", height: "100%" }}>
            <SubmenuHeader {...this.props} header={I18n.t("admin_local.menus.wolt_administration")} />
            <div id="foodpandasynchronizer" style={{ overflowY: "hidden", height: "100%", width: "100%", paddingBottom: 12, }}>
                <div style={{ overflowY: "hidden", height: "100%", width: "100%" }}>
                    <Card style={{ width: "100%", background: "transparent", overflowY: "hidden", height: "-webkit-fill-available", }} >
                        <CardHeader title={I18n.t("admin_local.status")} action={null} />
                        <CardContent style={{ background: "transparent", overflowY: "auto", height: "100%", width: "100%" }}>
                            {this.props.myStatus.restaurant_settings["enabled-features"].wolt.places ? this.props.myStatus.restaurant_settings["enabled-features"].wolt.places.filter(p => p.enabled).map(place =>
                                <div key={place.name} style={{ marginBottom: 24, padding: 12, border: "1px solid #eee", borderRadius: 8, background: "#fafafa" }}>
                                    <div style={{ fontWeight: "bold", fontSize: "1.2rem", marginBottom: 8 }}>{place.name}</div>
                                    <div style={{ display: "flex", gap: 12 }}>
                                        {!place.selfService || place.accessToken ?
                                            <Button variant="contained" color="primary" onClick={() => this.onClick(place.name)}>
                                                {I18n.t("admin_local.upload_menu")}
                                            </Button> :
                                            <WoltOAuth instanceId={place.name} test={!!place.test} />
                                        }
                                    </div>
                                </div>
                            ) : null}
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    }


    onClick = (name) => {
        get("integration/wolt/syncMenu/" + this.props.myStatus.restaurant_id + "/" + name).done(res => {
            if (res.status === "done")
                messageDialog(I18n.t("local.information"), I18n.t("admin_local.upload_successful"));
            else
                messageDialog(I18n.t("local.error_message"), res.message).done(() => window.location.reload()).fail(() => window.location.reload());
        });
    }


}



const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            myStatus: props.rootReducer.myStatus,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(Wolt));
